/*
 * Quiz Rejuderme
 * Lógica de navegação, estado, personalização e tracking.
 * Escopo isolado: tudo vive dentro de [data-quiz-root].
 */
(function () {
  'use strict';

  var IS_EDITOR = !!(window.Shopify && window.Shopify.designMode);
  var EDITOR_STATE_KEY = '_rej_quiz_editor_block_id';

  function bootQuiz() {
  var root = document.querySelector('[data-quiz-root]');
  if (!root) return;

  // ----- Config vindo do Liquid -----
  var config = {
    pdpUrl: root.dataset.pdpUrl || '/products/plaquinha-do-colo',
    analyticsPrefix: root.dataset.analyticsPrefix || 'quiz_rejuderme_',
    enableNameCapture: root.dataset.enableNameCapture === 'true',
    cookieDays: parseInt(root.dataset.cookieDays || '1', 10),
    apiEndpoint: root.dataset.apiEndpoint || '',
    apiToken: root.dataset.apiToken || '',
    swipe: root.dataset.swipe === '1',
    reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches
  };

  // ----- Seleção de telas -----
  var allScreens = Array.prototype.slice.call(root.querySelectorAll('.quiz-screen'));
  var screens = allScreens.filter(function (s) {
    if (s.dataset.screenType === 'name-capture' && !config.enableNameCapture) return false;
    return true;
  });

  if (!screens.length) return;

  // Hide the skipped name-capture if present
  if (!config.enableNameCapture) {
    allScreens.forEach(function (s) {
      if (s.dataset.screenType === 'name-capture') s.style.display = 'none';
    });
  }

  // ----- Estado -----
  var totalQuestions = screens.filter(function (s) { return s.dataset.screenType === 'question'; }).length;

  var state = {
    currentIndex: 0,
    answers: {},
    multiSelection: {}, // question_id -> Set of values
    name: '',
    sessionUid: '',
    screenEnteredAt: Date.now()
  };

  window.rejudermeQuiz = state;

  // ----- Cookies + UUID -----
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }
  function uuidv4() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  state.sessionUid = getCookie('_rej_quiz_sid') || uuidv4();
  if (config.cookieDays > 0) setCookie('_rej_quiz_sid', state.sessionUid, config.cookieDays);

  // ----- UTMs + contexto -----
  function parseUtms() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = params.get(k);
      if (v) utm[k.replace('utm_', '')] = v;
    });
    return utm;
  }
  function detectDevice() {
    var w = window.innerWidth || 0;
    if (w < 768) return 'mobile';
    if (w < 1024) return 'tablet';
    return 'desktop';
  }

  // ----- API (fail-silent quando não configurado) -----
  function apiPost(path, payload) {
    if (!config.apiEndpoint) return Promise.resolve();
    var url = config.apiEndpoint.replace(/\/$/, '') + path;
    var headers = { 'Content-Type': 'application/json' };
    if (config.apiToken) headers['Authorization'] = 'Bearer ' + config.apiToken;
    return fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: 'omit',
      mode: 'cors'
    }).catch(function () { /* silencioso */ });
  }

  // ----- Analytics dataLayer -----
  function trackEvent(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = Object.assign({ event: config.analyticsPrefix + name }, data || {});
      window.dataLayer.push(payload);
    } catch (_) { /* noop */ }
  }

  // ----- Progresso -----
  var progressFill = root.querySelector('[data-quiz-progress-fill]');
  var progressBar = root.querySelector('[data-quiz-progress]');
  function updateProgress() {
    var questionsSeen = 0;
    for (var i = 0; i <= state.currentIndex; i++) {
      if (screens[i] && screens[i].dataset.screenType === 'question') questionsSeen++;
    }
    var denominator = Math.max(totalQuestions, 1);
    var pct = Math.min(100, Math.round((questionsSeen / denominator) * 100));
    // Welcome = 0%, diagnóstico = 100%
    if (state.currentIndex >= screens.length - 1) pct = 100;
    if (state.currentIndex === 0) pct = 0;
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressBar) progressBar.setAttribute('aria-valuenow', String(pct));
  }

  // ----- Back button -----
  var backBtn = root.querySelector('[data-quiz-back]');
  function updateBackBtn() {
    if (!backBtn) return;
    var current = screens[state.currentIndex];
    var hide = !current
      || state.currentIndex === 0
      || current.dataset.screenType === 'loading'
      || current.dataset.screenType === 'diagnosis';
    backBtn.hidden = hide;
  }

  // ----- Navegação de telas -----
  function showScreen(index) {
    if (index < 0 || index >= screens.length) return;
    var prev = screens[state.currentIndex];
    var next = screens[index];
    if (!next) return;

    if (prev && prev !== next) prev.classList.remove('is-active');
    next.classList.add('is-active');

    state.currentIndex = index;
    state.screenEnteredAt = Date.now();

    updateProgress();
    updateBackBtn();
    focusFirstInteractive(next);
    scrollScreenToTop(next);
    trackEvent('screen_view', { screen_index: index, screen_type: next.dataset.screenType });

    // Hooks específicos
    if (next.dataset.screenType === 'loading') runLoading(next);
    if (next.dataset.screenType === 'diagnosis') renderDiagnosis(next);
  }

  function focusFirstInteractive(screen) {
    var el = screen.querySelector('.quiz-option, input, .quiz-cta, [data-quiz-next], [data-quiz-name-submit]');
    if (el) {
      try { el.focus({ preventScroll: true }); } catch (_) { /* no-op if browser refocuses */ }
    }
  }

  function scrollScreenToTop(screen) {
    var anchor = root || screen;
    try {
      anchor.scrollIntoView({ behavior: config.reducedMotion ? 'auto' : 'smooth', block: 'start' });
    } catch (_) {
      var top = anchor.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo(0, top);
    }
  }

  function nextScreen() {
    // Pula name-capture se desativado
    var next = state.currentIndex + 1;
    while (next < screens.length && screens[next].dataset.screenType === 'name-capture' && !config.enableNameCapture) {
      next++;
    }
    showScreen(next);
  }

  function prevScreen() {
    var prev = state.currentIndex - 1;
    while (prev >= 0 && screens[prev].dataset.screenType === 'name-capture' && !config.enableNameCapture) {
      prev--;
    }
    showScreen(Math.max(0, prev));
  }

  // ----- Registrar resposta -----
  function recordAnswer(screen, value, label) {
    var qid = screen.dataset.questionId;
    var idx = Array.prototype.indexOf.call(screens, screen);
    var answerType = screen.dataset.answerType || 'single';
    var elapsed = Date.now() - state.screenEnteredAt;

    var answerValue, answerLabel;
    if (answerType === 'multi') {
      var set = state.multiSelection[qid] || [];
      answerValue = set.join(',');
      answerLabel = set.map(function (v) {
        var btn = screen.querySelector('.quiz-option[data-option-value="' + CSS.escape(v) + '"]');
        return btn ? btn.dataset.optionLabel : v;
      }).join(', ');
    } else {
      answerValue = value;
      answerLabel = label;
    }

    state.answers[qid] = answerType === 'multi' ? (state.multiSelection[qid] || []) : answerValue;

    trackEvent('answer_' + qid, { value: answerValue });
    apiPost('/api/quiz/answer', {
      session_uid: state.sessionUid,
      question_id: qid,
      question_index: idx,
      answer_value: answerValue,
      answer_label: answerLabel,
      time_to_answer_ms: elapsed
    });
  }

  // ----- Setup handlers por tela -----
  screens.forEach(function (screen, idx) {
    var type = screen.dataset.screenType;

    if (type === 'welcome') {
      var start = screen.querySelector('[data-quiz-next]');
      if (start) start.addEventListener('click', function () { nextScreen(); });
    }

    if (type === 'question') {
      var options = Array.prototype.slice.call(screen.querySelectorAll('.quiz-option'));
      var answerType = screen.dataset.answerType || 'single';
      var qid = screen.dataset.questionId;
      var continueBtn = screen.querySelector('[data-quiz-continue]');

      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          var value = opt.dataset.optionValue;
          var label = opt.dataset.optionLabel;

          if (answerType === 'multi') {
            state.multiSelection[qid] = state.multiSelection[qid] || [];
            var list = state.multiSelection[qid];
            var i = list.indexOf(value);
            if (i === -1) {
              list.push(value);
              opt.classList.add('is-selected');
              opt.setAttribute('aria-checked', 'true');
            } else {
              list.splice(i, 1);
              opt.classList.remove('is-selected');
              opt.setAttribute('aria-checked', 'false');
            }
            if (continueBtn) continueBtn.disabled = list.length === 0;
          } else {
            options.forEach(function (o) {
              o.classList.remove('is-selected');
              o.setAttribute('aria-checked', 'false');
            });
            opt.classList.add('is-selected');
            opt.setAttribute('aria-checked', 'true');
            recordAnswer(screen, value, label);
            setTimeout(nextScreen, 220);
          }
        });
      });

      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          recordAnswer(screen);
          nextScreen();
        });
      }
    }

    if (type === 'name-capture') {
      var input = screen.querySelector('[data-quiz-name-input]');
      var submit = screen.querySelector('[data-quiz-name-submit]');
      if (input && submit) {
        submit.addEventListener('click', function () {
          var val = (input.value || '').trim();
          if (!val) {
            input.focus();
            return;
          }
          state.name = val.charAt(0).toUpperCase() + val.slice(1);
          nextScreen();
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') submit.click();
        });
      }
    }

    if (type === 'diagnosis') {
      var primaryCta = screen.querySelector('[data-quiz-cta-primary]');
      if (primaryCta) {
        primaryCta.addEventListener('click', function (e) {
          e.preventDefault();
          trackEvent('cta_click');
          apiPost('/api/quiz/cta-click', { session_uid: state.sessionUid });

          // Já grava o atributo no carrinho Shopify, pra robustez da atribuição
          try {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
              body: 'attributes[rej_quiz_sid]=' + encodeURIComponent(state.sessionUid),
              credentials: 'same-origin',
              keepalive: true
            }).catch(function () {});
          } catch (_) {}

          var baseUrl = primaryCta.getAttribute('href') || config.pdpUrl;
          var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
          var target = baseUrl + separator + 'rej_quiz_sid=' + encodeURIComponent(state.sessionUid);
          setTimeout(function () { window.location.href = target; }, 120);
        });
      }
      var secondaryCta = screen.querySelector('[data-quiz-cta-secondary]');
      if (secondaryCta) {
        secondaryCta.addEventListener('click', function () {
          var faq = document.getElementById('quiz-faq') || document.querySelector('.quiz-mechanism');
          if (faq) faq.scrollIntoView({ behavior: config.reducedMotion ? 'auto' : 'smooth', block: 'start' });
        });
      }
    }
  });

  // ----- Back button handler -----
  if (backBtn) {
    backBtn.addEventListener('click', function () { prevScreen(); });
  }

  // ----- Loading screen -----
  function runLoading(screen) {
    var fill = screen.querySelector('[data-quiz-loading-fill]');
    var line = screen.querySelector('[data-quiz-loading-line]');
    var duration = parseInt(screen.dataset.duration || '3500', 10);
    var lines = line && line.dataset.lines ? line.dataset.lines.split('|') : [];

    // Ship diagnosis event fire once we reach loading (persona graduation)
    trackEvent('loading_shown');
    apiPost('/api/quiz/session/complete', {
      session_uid: state.sessionUid,
      name: state.name || null,
      answers: state.answers
    });

    if (config.reducedMotion) {
      if (fill) fill.style.width = '100%';
      setTimeout(nextScreen, 300);
      return;
    }

    // Bar
    if (fill) {
      fill.style.transitionDuration = duration + 'ms';
      requestAnimationFrame(function () { fill.style.width = '100%'; });
    }

    // Rotate lines
    if (line && lines.length > 1) {
      var step = duration / lines.length;
      lines.forEach(function (txt, i) {
        if (i === 0) return;
        setTimeout(function () {
          line.classList.add('is-fading');
          setTimeout(function () {
            line.textContent = txt;
            line.classList.remove('is-fading');
          }, 180);
        }, Math.floor(step * i));
      });
    }

    setTimeout(function () {
      if (state.currentIndex === Array.prototype.indexOf.call(screens, screen)) nextScreen();
    }, duration + 120);
  }

  // ----- Diagnóstico: personalização -----
  var DIAG_MAPS = {
    age: {
      '25-34': 'ainda na sua faixa dos 20 ou 30',
      '35-44': 'aos seus 30 ou 40',
      '45-54': 'na faixa dos 40 ou 50',
      '55+': 'depois dos 55'
    },
    sleep: {
      'lado-esquerdo': 'dormir do lado esquerdo',
      'lado-direito': 'dormir do lado direito',
      'alterno': 'alternar os lados ao dormir',
      'costas': 'dormir de costas',
      'bruco': 'dormir de bruços'
    },
    marks: {
      'frequente': 'acorda quase todo dia com marcas no colo',
      'as-vezes': 'percebe marcas no colo de vez em quando pela manhã',
      'raramente': 'raramente vê marcas pela manhã',
      'nunca-percebi': 'nunca tinha reparado nas marcas matinais'
    },
    concern: {
      'linhas-verticais': 'as linhas verticais entre os seios',
      'pele-crepada': 'a textura mais fina, quase crepada',
      'marcas-fixas': 'as marcas que antes sumiam e agora ficaram fixas',
      'evito-olhar': 'o desconforto de olhar o colo no espelho'
    },
    years: {
      'menos-5': 'há menos de 5 anos',
      '5-10': 'há 5 a 10 anos',
      '10-20': 'há mais de uma década',
      'mais-20': 'há mais de 20 anos'
    },
    context: {
      'decote': 'pra você voltar a usar decote sem pensar duas vezes',
      'fotos': 'pra que as fotos com quem você ama voltem a ser tranquilas',
      'praia-piscina': 'pra você curtir praia e piscina sem disfarce',
      'intimidade': 'pra que os momentos íntimos voltem a ser só seus',
      'escondo': 'pra você parar de esconder o colo'
    },
    openness: {
      'ja-quero': '',
      'entender': 'Leva só as noites que você já ia dormir mesmo.',
      'confortavel': 'É silicone fininho, sem cola agressiva, pra dormir confortável.',
      'ceticismo': 'Sem promessa mágica: é mecânica simples, testada por mais de 12 mil mulheres.'
    }
  };

  function buildPersonalizedIntro(answers, name) {
    var namePrefix = name ? name + ', ' : 'Olha, ';
    var age = DIAG_MAPS.age[answers.q1_age];
    var sleep = DIAG_MAPS.sleep[answers.q2_sleep_position];
    var marks = DIAG_MAPS.marks[answers.q3_morning_marks];
    var concern = DIAG_MAPS.concern[answers.q6_main_concern];
    var years = DIAG_MAPS.years[answers.q8_years_sleeping];
    var isBackSleeper = answers.q2_sleep_position === 'costas';

    var paragraphs = [];

    if (isBackSleeper) {
      paragraphs.push(namePrefix + 'você é a exceção que confirma a regra: dorme de costas.');
      if (concern) {
        paragraphs.push('Mesmo assim, o que mais te incomoda hoje é ' + concern + '.');
      }
      paragraphs.push('Como você não comprime o colo dormindo de lado, no seu caso a causa é outra: perda de elasticidade e hidratação noturna' +
        (years ? ', agravada por ' + years + ' sem um cuidado específico pra essa região' : ', agravada pela falta de um cuidado específico pra essa região') + '.');
      paragraphs.push('A boa notícia: o mesmo protocolo que a gente vai mostrar resolve os dois cenários.');
    } else {
      var intro = namePrefix;
      if (age && concern) {
        intro += age + ', o que mais te incomoda hoje é ' + concern + '.';
      } else if (concern) {
        intro += 'o que mais te incomoda hoje é ' + concern + '.';
      } else if (age) {
        intro += age + ', você já percebe que o seu colo está pedindo um olhar diferente.';
      } else {
        intro += 'seu colo está pedindo um olhar diferente do que você dá pro rosto.';
      }
      paragraphs.push(intro);

      if (marks) {
        paragraphs.push('E isso não é sol, nem idade, nem genética. O fato de você ' + marks + ' já é o primeiro sinal.');
      } else {
        paragraphs.push('E isso não é sol, nem idade, nem genética.');
      }

      if (sleep && years) {
        paragraphs.push('A causa está em ' + sleep + ' ' + years + ':');
        paragraphs.push('Seu colo passa a noite dobrado na mesma direção, e a pele começa a memorizar essa dobra.');
      } else if (sleep) {
        paragraphs.push('A causa está em ' + sleep + ':');
        paragraphs.push('O colo passa a noite dobrado na mesma direção, e a pele memoriza essa dobra.');
      } else {
        paragraphs.push('A causa é mecânica: o colo passa horas dobrado toda noite e a pele memoriza essa posição.');
      }
    }

    return paragraphs.map(function (p) { return '<p>' + p + '</p>'; }).join('');
  }

  function buildPersonalNudge(answers, name) {
    var prefix = name ? name + ', ' : '';
    var ctx = DIAG_MAPS.context[answers.q10_context] || 'pra você voltar a ter o colo que já teve';
    var openTxt = DIAG_MAPS.openness[answers.q11_openness] || '';
    var line = prefix + 'pela combinação das suas respostas, esse é o caminho ' + ctx + '.';
    if (openTxt) line += ' ' + openTxt;
    return line;
  }

  function renderDiagnosis(screen) {
    var headlineEl = screen.querySelector('[data-headline-template]');
    if (headlineEl) {
      var tpl = (headlineEl.dataset.headlineTemplate || '').trim();
      var fallback = headlineEl.dataset.headlineFallback || '';
      var name = state.name || '';
      var tokenRe = /%nome%|\{\{\s*nome\s*\}\}/g;
      var hasToken = tokenRe.test(tpl);
      tokenRe.lastIndex = 0;
      var rendered;
      if (!tpl) {
        rendered = fallback;
      } else if (hasToken && name) {
        rendered = tpl.replace(tokenRe, name);
      } else if (hasToken) {
        // Sem nome: remove o token + vírgula/espaço logo depois, e recapitaliza
        rendered = tpl.replace(/(?:%nome%|\{\{\s*nome\s*\}\})\s*,?\s*/g, '').trim();
        if (rendered) rendered = rendered.charAt(0).toUpperCase() + rendered.slice(1);
        if (!rendered) rendered = fallback;
      } else {
        rendered = tpl;
      }
      headlineEl.textContent = rendered;
    }

    // Seção B personalizada com base nas respostas
    var sectionBDefault = screen.querySelector('[data-variant-target="section-b"] [data-variant="default"]');
    if (sectionBDefault) {
      sectionBDefault.innerHTML = buildPersonalizedIntro(state.answers, state.name);
    }
    // Esconde o p2 original, pq o novo texto já entrega os dois parágrafos
    var sectionBSibling = screen.querySelectorAll('[data-variant-target="section-b"] + section .quiz-prose, [data-variant-target="section-b"] ~ section .quiz-prose');
    // (o p2 da schema fica no mesmo [data-variant-target="section-b"] section se existir - ver liquid)
    var sectionBWrap = screen.querySelector('[data-variant-target="section-b"]');
    if (sectionBWrap) {
      var extras = sectionBWrap.querySelectorAll('.quiz-prose:not([data-variant="default"])');
      extras.forEach(function (el) { el.style.display = 'none'; });
    }

    // Nudge personalizado logo antes do título da oferta
    var offerSection = screen.querySelector('.quiz-offer');
    if (offerSection && !offerSection.querySelector('.quiz-personal-nudge')) {
      var nudge = document.createElement('p');
      nudge.className = 'quiz-personal-nudge';
      nudge.textContent = buildPersonalNudge(state.answers, state.name);
      offerSection.insertBefore(nudge, offerSection.firstChild);
    }

    trackEvent('diagnosis_shown');
  }

  // ----- Teclado -----
  document.addEventListener('keydown', function (e) {
    var current = screens[state.currentIndex];
    if (!current) return;
    if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;

    if (e.key === 'ArrowLeft' && state.currentIndex > 0) {
      e.preventDefault();
      prevScreen();
    }
    if (e.key === 'Enter' && current.dataset.screenType === 'welcome') {
      var btn = current.querySelector('[data-quiz-next]');
      if (btn) btn.click();
    }
  });

  // ----- Swipe mobile -----
  if (config.swipe && !config.reducedMotion) {
    var touchStartX = 0;
    var touchStartY = 0;
    root.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!e.changedTouches || !e.changedTouches[0]) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 60 || Math.abs(dy) > 40) return;
      var cur = screens[state.currentIndex];
      if (cur && (cur.dataset.screenType === 'loading' || cur.dataset.screenType === 'diagnosis')) return;
      if (dx > 0) prevScreen();
      // swipe pra esquerda NÃO avança (precisa escolher resposta)
    }, { passive: true });
  }

  // ----- Theme editor helpers -----
  function findScreenIndexByBlockId(blockId) {
    if (!blockId) return -1;
    for (var i = 0; i < screens.length; i++) {
      if (screens[i].dataset.blockId === blockId) return i;
    }
    return -1;
  }

  function navigateToBlock(blockId) {
    var idx = findScreenIndexByBlockId(blockId);
    if (idx >= 0) showScreen(idx);
  }

  // Expose for the outer editor listener
  state.navigateToBlock = navigateToBlock;
  state.findScreenIndexByBlockId = findScreenIndexByBlockId;

  // Persist screen on every navigation when in editor, so a save keeps the user in place
  if (IS_EDITOR) {
    var _origShowScreen = showScreen;
    showScreen = function (index) {
      _origShowScreen(index);
      var cur = screens[state.currentIndex];
      if (cur && cur.dataset.blockId) {
        try { sessionStorage.setItem(EDITOR_STATE_KEY, cur.dataset.blockId); } catch (_) {}
      }
    };
  }

  // ----- Init -----
  function init() {
    screens.forEach(function (s) { s.classList.remove('is-active'); });
    if (screens[0]) screens[0].classList.add('is-active');
    updateProgress();
    updateBackBtn();

    // In the theme editor: skip analytics and restore the last screen if there is one
    if (IS_EDITOR) {
      var savedBlockId = null;
      try { savedBlockId = sessionStorage.getItem(EDITOR_STATE_KEY); } catch (_) {}
      if (savedBlockId) {
        var idx = findScreenIndexByBlockId(savedBlockId);
        if (idx > 0) showScreen(idx);
      }
      return;
    }

    trackEvent('start');
    apiPost('/api/quiz/session/start', {
      session_uid: state.sessionUid,
      utm: parseUtms(),
      referrer: document.referrer || '',
      user_agent: navigator.userAgent || '',
      device: detectDevice()
    });
  }

  init();
  } // end bootQuiz

  bootQuiz();

  // ----- Theme editor integration (outside the boot closure so it survives section reloads) -----
  if (IS_EDITOR) {
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector) return;
      if (e.target.querySelector('[data-quiz-root]') || e.target.matches('[data-quiz-root]')) {
        bootQuiz();
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var blockId = e.detail && e.detail.blockId;
      if (!blockId) return;
      try { sessionStorage.setItem(EDITOR_STATE_KEY, blockId); } catch (_) {}
      if (window.rejudermeQuiz && typeof window.rejudermeQuiz.navigateToBlock === 'function') {
        window.rejudermeQuiz.navigateToBlock(blockId);
      }
    });
  }
})();
